<template>
    <div :style="{'height' : messageHeight + '%'}">
        <text-only-message v-if="message.pictures.length == 0" :message="message" :wideImage="wideImage"></text-only-message>

        <image-only-message v-else-if="message.message === ''" :message="message" :wideImage="wideImage"></image-only-message>

        <above-image v-else-if="isPortrait && message.sticky !== true && pageMessageCount <= 2" :message="message" :wideImage="wideImage"></above-image>

        <beside-image v-else :message="message" :imgSide="imgSide" :wideImage="wideImage"></beside-image>
    </div>
</template>

<script>
    import Vue from 'vue';
    import TextOnlyMessage from './message-layouts/text-only-message';
    import ImageOnlyMessage from './message-layouts/image-only-message';
    import AboveImage from './message-layouts/above-image';
    import BesideImage from './message-layouts/beside-image';

    Vue.component('text-only-message', TextOnlyMessage);
    Vue.component('image-only-message', ImageOnlyMessage);
    Vue.component('above-image', AboveImage);
    Vue.component('beside-image', BesideImage);

    export default {
        data() {
            return {
                wideImage: true,
                isPortrait: {},
                imgSide: {}
            }
        },
        methods: {
            setupLayout: function () {
                var self = this;

                if (this.message.pictures.length > 0) {
                    var img = new Image();

                    img.onload = function () {
                        self.wideImage = this.width > this.height;
                    }

                    var pictureId = this.message.pictures[0].noticePictureId;
                    var pictureType = this.message.pictures[0].type;
                    img.src = this.$http.defaults.baseURL + 'digitalNoticeBoard/picture?picture_id=' + pictureId + '&type=' + pictureType
                }

                if (this.message.imagePosition) {
                    this.imgSide = message.imagePosition;
                } else if (this.$kmsTheme && this.$kmsTheme.layout && this.$kmsTheme.layout.messageImagePosition) {
                    this.imgSide = this.$kmsTheme.layout.messageImagePosition;
                } else {
                    this.imgSide = "left";
                }
            },
            
        },
        props: {
            message: {

            },
            pageMessageCount: {

            },
            messageHeight: {

            },
            stickyHeight: {

            }
        },
        created() {
            this.isPortrait = window.screen.height > window.screen.width;
            this.setupLayout();
        }
    }



</script>
<style>
    .imgRowWrapper {
        height: 100%;
    }    

    .resize {
        overflow-wrap: break-word;
        text-align: center;
        white-space: pre-line;
        margin-block-end: 0px;
        margin-block-start: 0px;
    }

    .wideImage {
        width: 100%;
    }

    .tallImage {
        height: 100%;
    }

   
</style>
